

/*import { createToaster } from "@meforma/vue-toaster";*/
import axiosInstance from "./api";
/*import TokenService from "./token.service";*/
//const privateEnvVar = import.meta.env.SERVER_SIDE_ONLY_VAR;

const setup = (store) => {
    axiosInstance.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("access_token"); //TokenService.getLocalAccessToken();
            // alert(privateEnvVar);
            if (token != null) {
                if (config["Content-Type"] == "multipart/form-data") {
                    config.headers["Content-Type"] = "multipart/form-data";
                } else {
                    config.headers["Content-Type"] = "application/json";
                }
                    config.headers['Access-Control-Allow-Origin'] = '*',
                    config.headers['Access-Control-Allow-Methods'] = 'GET,POST, PATCH,PUT,DELETE,OPTIONS',
                    config.headers['Access-Control-Allow-Headers'] = 'Origin, Content-Type, X-Auth-Token Origin,X-Requested-With,Accept',
                    config.headers['Cache-Control'] = 'no-cache',//, no-store, must-revalidate, post-check=0, pre-check=0',
                    config.headers['Pragma'] = 'no-cache',
                    config.headers['Expires'] = 'Sat, 01 Jan 2000 00:00:00 GMT',
                    config.headers['If-Modified-Since'] = '0',
                    //config.headers['Content-Type'] = 'multipart/form-data',
                    config.headers['Authorization'] = 'Bearer ' + localStorage.getItem("access_token")

                //config.headers["x-access-token"] = ""; // for Node.js Express back-end
                //config.headers.common.Accept = 'Application/json';
                //config.headers['Access-Control-Allow-Origin'] = '*';
                //config.headers['Authorization'] = 'token_value ' + localStorage.getItem("access_token")

            }
            else {

                config.headers["Content-Type"] = "application/json",
                    config.headers['Access-Control-Allow-Origin'] = '*',
                    config.headers['Access-Control-Allow-Methods'] = 'GET,POST, PATCH,PUT,DELETE,OPTIONS',
                    config.headers['Access-Control-Allow-Headers'] = 'Origin, Content-Type, X-Auth-Token',
                    config.headers['Cache-Control'] = 'no-cache',//, no-store, must-revalidate, post-check=0, pre-check=0',
                    config.headers['Pragma'] = 'no-cache',
                    config.headers['Expires'] = 'Sat, 01 Jan 2000 00:00:00 GMT',
                    config.headers['If-Modified-Since'] = '0',
                    //config.headers['Content-Type'] = 'multipart/form-data',
                    config.headers['Authorization'] = 'Bearer ' + ""

            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    axiosInstance.interceptors.response.use(
        (res) => {
            return res;
        },
        async (err) => {
            const originalConfig = err.config;

            if (originalConfig.url !== "/auth/signin" && err.response) {
                // Access Token was expired
                if (err.response.status === 401 && !originalConfig._retry) {
                    originalConfig._retry = true;

                    try {
                        const rs = await axiosInstance.post("/auth/refreshtoken", {
                            refreshToken: localStorage.getItem("access_token"),
                        });

                        const { accessToken } = rs.data;

                        store.dispatch('auth/refreshToken', accessToken);


                        return axiosInstance(originalConfig);
                    } catch (_error) {
                        return Promise.reject(_error);
                    }
                }
            }

            return Promise.reject(err);
        }
    );
};

export default setup;